module.exports = __webpack_public_path__ + "media/images/emoticons/t-shirt-108efb28536ce95bad048e64d6a2c831.gif";